// import { Chat } from '@/shared/interfaces/Chat'
import { ApiHandler } from '@/shared/api/ApiHandler'

export async function chatsGetById(
  chatId: number,
): Promise<any> {
  return await ApiHandler.get(
    `chats/${chatId}`,
  )
}
